import { render, staticRenderFns } from "./ai_img.vue?vue&type=template&id=22f27e72&scoped=true"
import script from "./ai_img.vue?vue&type=script&lang=js"
export * from "./ai_img.vue?vue&type=script&lang=js"
import style0 from "./ai_img.vue?vue&type=style&index=0&id=22f27e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f27e72",
  null
  
)

export default component.exports